import { useEffect, useMemo, useState } from 'react';
import { router } from '../../lib/router';
import List from './List.tsx';
import Detail from './Detail.tsx';

function usePath() {
  const [path, setPath] = useState<string>(() => router.getCurrentPath());
  useEffect(() => router.subscribe(setPath), []);
  return path;
}

export default function BlogRouter() {
  const path = usePath();
  const view = useMemo(() => {
    if (!path.startsWith('/blog') && !path.startsWith('/learn')) return { type: 'none' as const };
    // `router.getCurrentPath()` includes the query string (e.g. "/blog?q=foo").
    // Only the pathname should decide list vs detail; query params are for list filters.
    let pathnameOnly = path;
    try {
      // Works with both "/blog?q=foo" and "/blog/some-slug?x=y"
      pathnameOnly = new URL(path, window.location.origin).pathname;
    } catch {}
    const basePath = pathnameOnly.startsWith('/learn') ? '/learn' : '/blog';
    const slug = pathnameOnly.replace(/^\/(blog|learn)\/?/, '');
    if (!slug) return { type: 'list' as const };
    return { type: 'detail' as const, slug, basePath };
  }, [path]);

  if (view.type === 'list') {
    const basePath = path.startsWith('/learn') ? '/learn' : '/blog';
    return <List basePath={basePath} />;
  }
  if (view.type === 'detail') return <Detail slug={view.slug} basePath={view.basePath} />;
  return null;
}


